// src/components/Home.js
import React from "react";
import "./Home.css";

function Home() {
  return (
    <div className="home-page">
      <div className="content">
        <h1>Welcome to GemmiyMind</h1>
        <p>Find calm and serenity in a busy world</p>
      </div>
    </div>
  );
}

export default Home;
